import React, { useState } from 'react'
import { Button } from 'antd'

interface Props {
  availableCommentsForEditing?: string[]
  prevComments?: string | null
  doSave: (comments: string) => void
}

const AssetsCommentsForEditing = ({
  availableCommentsForEditing,
  prevComments,
  doSave,
}: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(true)
  const selectedComments = prevComments ? prevComments.split(",") : []

  const toggleComment = (comment: string, checked: boolean) => {
    const comments = checked
      ? [...selectedComments, comment]
      : selectedComments.filter((sl) => sl !== comment)

    doSave(comments.join(","))
  }

  if (
    !availableCommentsForEditing ||
    availableCommentsForEditing.length === 0
  ) {
    return (
      <div>Det er ikke mulig å legge til kommentarer for dette bildet.</div>
    )
  }

  return (
    <div className="labels-wrapper block" style={{ marginTop: '14px' }}>
      <h4 style={{ marginBottom: 0 }}>
        Kommentarer til desk ({selectedComments.length}){' '}
        <Button
          size="small"
          onClick={() => setIsOpen((prevValue) => !prevValue)}
        >
          {isOpen ? 'Skjul' : 'Vis'}
        </Button>
      </h4>
      {isOpen && (
        <div>
          {availableCommentsForEditing.map((comment, i) => {
            return (
              <label key={i}>
                <input
                  checked={selectedComments.includes(comment)}
                  type="checkbox"
                  key={i}
                  onChange={(e) => {
                    toggleComment(comment, e.target.checked)
                  }}
                />
                {comment}
              </label>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default AssetsCommentsForEditing
